import { Stack } from '@mantine/core';
import OrganizationList from 'components/OrganizationList';
import ProvenanceLabel from 'components/ProvenanceLabel';
import { RevisionTemplateRow } from 'components/tables/data/revision-template/types';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for the restrictions.
 */
export default function RestrictionsColumn({
  data: { isGlobal, isOrganization, organizations, blacklistedOrganizations },
}: {
  data: RevisionTemplateRow;
}) {
  return (
    <P2Regular color="gray.8">
      {isGlobal && (
        <Stack spacing={8}>
          <ProvenanceLabel provenance="global" />
          {blacklistedOrganizations?.length > 0 && (
            <Stack spacing={8}>
              <ProvenanceLabel
                provenance="organization"
                organizationLabel="Nedostupná pre organizácie:"
                organizationExcluded
              />
              <OrganizationList organizations={blacklistedOrganizations} />
            </Stack>
          )}
        </Stack>
      )}
      {isOrganization && (
        <Stack spacing={8}>
          <ProvenanceLabel provenance="organization" />
          <OrganizationList organizations={organizations!} />
        </Stack>
      )}
    </P2Regular>
  );
}
